import { providerAgreementListAPI } from "@/views/ProviderAgreementList/services/api";

export const getProviderAgreementList = async () => {
  try {
    const res = await providerAgreementListAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const providerAgreementListColumns = [
  {
    name: "contractor_agreement_list_id",
    field: "contractor_agreement_list_id",
    label: "ID",
    align: "center",
    sortable: true,
    style: "width: 80px",
  },
  {
    name: "contractor_name",
    field: "contractor_name",
    label: "Застройщик",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "agreement_num",
    field: "agreement_num",
    label: "Номер договора",
    align: "left",
    sortable: true,
    style: "min-width: 150px",
  },
  {
    name: "document_date",
    field: "document_date",
    label: "Дата документа",
    align: "center",
    sortable: true,
    style: "width: 120px",
  },
  {
    name: "sbs_project_name",
    field: "sbs_project_name",
    label: "Проект",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "sign_status",
    field: "sign_status",
    label: "Подписание",
    align: "center",
    sortable: false,
    style: "min-width: 180px",
  },
  {
    name: "actions",
    field: "actions",
    label: "Действия",
    align: "center",
    style: "width: 120px",
  },
];

